/**
 * This enum is holding all main role id's
 * - they do not have to change !
 */
export enum RolesSystem {
  PROMOTER = "5c1b6105b1d7b1343e2ee9ba",
  CHECKER = "5c0aa4c7e9b5878743b77488",
  ADMIN = "5c0aa4d5e9b5878743b7748a",
  HOST = "5c0aa4cee9b5878743b77489",
  NOT_LOGGEDIN = "NOT_LOGGEDIN"
}

/**
 * Could be used as "translation" from roleId to it's Name
 */
export const RolesSystemReverse = {
  [RolesSystem.HOST]: "Host",
  [RolesSystem.PROMOTER]: "Promoter",
  [RolesSystem.CHECKER]: "Ticket Scanner",
  [RolesSystem.NOT_LOGGEDIN]: "Delete"
};



// WEBPACK FOOTER //
// ./src/lib/enums/RolesSystem.enum.ts